//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The profession, category, and format courses pages are almost identical. I tried to make them a single generic
 * page, but the issue is that each type has a different group of icons below the header image. The other thought
 * is to have a component that loads the bottom icons and then have a main page that loads the data needed for
 * the page to load fully. The directory structure I used was `/courses/_type/_filter` and if there was not `filter`
 * in the `params` then I used the router redirect in the middleware to go back to `/courses` to load the page
 * without any filters applied.
 *
 * I think having different pages for each set is not a bad idea, just because if there are any issues with a specific
 * filter type then the entire courses directory structure does not have to change.
 */
import { mapActions, } from 'vuex';
import core from '../../../components/subcards/core.vue';
import professions from '@/data/distinctProfessions.json';
import { setCustomDimensionProfession, } from '@/services/gtmManager';

function getProfession ({ profession }) {
  console.log(`getProfession "${profession}"`);
  return professions[profession.toLowerCase()];
}

export default {
  name: 'ProfessionSearch',
  middleware ({
    store,
    params,
  }) {
    //
    store.dispatch('search/resetAndSet', {
      type: 'profession',
      ...getProfession(params),
    });
    store.dispatch('search/applyFilters');
  },
  asyncData ({ params }) {
    // ?auto=enhance&bri=-20&sat=-100&fit=crop,faces&w=1200&h=200
    const profession = getProfession(params);
    return {
      ...profession,
      showHeader: profession && profession.descriptiveParagraph && profession.imagePath,
    };
  },
  data () {
    return {
      showMore: false,
      gtmProfession: '',
    };
  },
  head () {
    return {
      title: this.name + ' CE Courses',
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.name + ' CE Courses',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.descriptiveParagraph,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.descriptiveParagraph,
        },
      ],
    };
  },
  computed: {
    core () {
      return core;
    },
  },
  beforeMount () {
    const profession = {
      type: 'profession',
      ...this.getProfession(this.$route.params.profession),
    };
    this.resetAndSetLocalStorage(profession);
    if (this.$auth.loggedIn) {
      switch (this.$route.params.profession) {
        case 'physical-therapist':
          this.gtmProfession = 'PT/PTA';
          break;
        case 'occupational-therapist':
          this.gtmProfession = 'OT/OTA';
          break;
        case 'speech-language-pathologist':
          this.gtmProfession = 'SLP';
          break;
        case 'other-professionals':
          this.gtmProfession = 'Other';
          break;
      }
      setCustomDimensionProfession(this.$gtm, this.gtmProfession);
    }
  },
  methods: {
    ...mapActions('search', ['removeFilter', 'resetAndSetLocalStorage']),
    getProfession (profession) {
      console.log(`getProfession "${profession}"`);
      return professions[profession.toLowerCase()];
    },
  },
};
